<template>
  <svg
    viewBox="0 0 367 292"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    overflow="hidden"
  >
    <defs>
      <clipPath id="outgoingClip0">
        <rect x="531" y="2668" width="367" height="292" />
      </clipPath>
      <clipPath id="outgoingClip1">
        <rect x="532" y="2686" width="273" height="273" />
      </clipPath>
      <clipPath id="outgoingClip2">
        <rect x="532" y="2686" width="273" height="273" />
      </clipPath>
      <clipPath id="outgoingClip3">
        <rect x="532" y="2686" width="273" height="273" />
      </clipPath>
    </defs>
    <g clip-path="url(#outgoingClip0)" transform="translate(-531 -2668)">
      <g clip-path="url(#outgoingClip1)">
        <g clip-path="url(#outgoingClip2)">
          <g clip-path="url(#outgoingClip3)">
            <path
              d="M624.345 2914.8C611.321 2928.43 589.715 2928.91 576.087 2915.89 562.46 2902.87 561.971 2881.26 574.996 2867.63 575.351 2867.26 575.715 2866.9 576.087 2866.54L627.305 2815.44C640.633 2802.12 662.235 2802.12 675.563 2815.44 682.078 2822.25 692.881 2822.49 699.692 2815.97 706.503 2809.46 706.743 2798.66 700.229 2791.84 700.051 2791.66 699.868 2791.48 699.682 2791.3 673.031 2764.65 629.821 2764.65 603.168 2791.3 603.168 2791.3 603.166 2791.3 603.166 2791.3L551.987 2842.48C525.329 2869.13 525.325 2912.35 551.978 2939 578.63 2965.66 621.845 2965.66 648.503 2939.01L674.102 2913.41C681.004 2906.99 681.395 2896.2 674.975 2889.29 668.556 2882.39 657.757 2882 650.855 2888.42 650.554 2888.7 650.264 2888.99 649.983 2889.29L624.345 2914.8ZM709.695 2829.56C696.367 2842.88 674.765 2842.88 661.437 2829.56 654.928 2822.75 644.125 2822.5 637.308 2829.01 630.491 2835.52 630.244 2846.32 636.753 2853.14 636.93 2853.32 637.112 2853.5 637.299 2853.68 663.949 2880.33 707.16 2880.34 733.812 2853.68 733.813 2853.68 733.814 2853.68 733.814 2853.68L784.993 2802.5C811.646 2775.85 811.646 2732.64 784.993 2705.99 758.341 2679.34 715.13 2679.34 688.478 2705.99L662.898 2731.59C655.996 2738.01 655.606 2748.8 662.025 2755.71 668.444 2762.61 679.243 2763 686.144 2756.58 686.446 2756.3 686.737 2756.01 687.017 2755.71L712.616 2730.13C725.214 2716.1 746.795 2714.95 760.817 2727.55 774.84 2740.14 775.995 2761.73 763.397 2775.75 762.578 2776.66 761.71 2777.53 760.797 2778.35L709.695 2829.56Z"
              fill="currentColor"
              fill-rule="evenodd"
            />
          </g>
        </g>
      </g>
      <path
        d="M713.185 2765.43C713.185 2716.55 752.583 2676.93 801.183 2676.93 849.787 2676.93 889.185 2716.55 889.185 2765.43 889.185 2814.31 849.787 2853.93 801.183 2853.93 752.583 2853.93 713.185 2814.31 713.185 2765.43Z"
        stroke="#FFFFFF"
        stroke-width="16"
        stroke-linecap="round"
        stroke-miterlimit="8"
        fill="currentColor"
        fill-rule="evenodd"
      />
      <path
        d="M834.839 2765.12 809 2737"
        stroke="#FFFFFF"
        stroke-width="18.3333"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        fill="#DAE0E6"
        fill-rule="evenodd"
      />
      <path
        d="M0 0 25.7874 28.0438"
        stroke="#FFFFFF"
        stroke-width="18.3333"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        fill="#DAE0E6"
        fill-rule="evenodd"
        transform="matrix(-1 1.22465e-16 1.22465e-16 1 834.787 2766)"
      />
      <path
        d="M824.973 2766 767 2766"
        stroke="#FFFFFF"
        stroke-width="18.3333"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        fill="#DAE0E6"
        fill-rule="evenodd"
      />
    </g>
  </svg>
</template>
